import { Component } from '@theme/component';

const MOBILE_MAX = 989;

export class BbdAnnouncementBar extends Component {
  #current = 0;
  #interval = undefined;
  #mq = window.matchMedia(`(max-width: ${MOBILE_MAX}px)`);

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('mouseenter', this.suspend);
    this.addEventListener('mouseleave', this.resume);
    document.addEventListener('visibilitychange', this.#handleVisibility);
    this.#mq.addEventListener('change', this.#handleMq);
    this.#handleMq();
  }

  disconnectedCallback() {
    super.disconnectedCallback?.();
    this.#mq.removeEventListener('change', this.#handleMq);
    document.removeEventListener('visibilitychange', this.#handleVisibility);
    this.suspend();
  }

  #handleMq = () => {
    if (this.#mq.matches) {
      this.current = 0;
      this.play();
    } else {
      this.suspend();
      this.refs.slides?.forEach((slide) => slide.removeAttribute('aria-hidden'));
    }
  };

  next() {
    this.current += 1;
  }

  previous() {
    this.current -= 1;
  }

  play(interval = this.autoplayInterval) {
    if (!this.autoplay) return;
    this.paused = false;
    this.#interval = setInterval(() => {
      if (this.matches(':hover') || document.hidden) return;
      this.next();
    }, interval);
  }

  pause() {
    this.paused = true;
    this.suspend();
  }

  get paused() {
    return this.hasAttribute('paused');
  }

  set paused(value) {
    this.toggleAttribute('paused', value);
  }

  suspend() {
    clearInterval(this.#interval);
    this.#interval = undefined;
  }

  resume() {
    if (!this.autoplay || this.paused) return;
    this.pause();
    this.play();
  }

  get autoplay() {
    return Boolean(this.autoplayInterval);
  }

  get autoplayInterval() {
    const value = parseInt(this.getAttribute('autoplay'), 10);
    return Number.isNaN(value) ? undefined : value * 1000;
  }

  get current() {
    return this.#current;
  }

  set current(current) {
    this.#current = current;
    const slides = this.refs.slides ?? [];
    let relativeIndex = current % slides.length;
    if (relativeIndex < 0) relativeIndex += slides.length;
    slides.forEach((slide, index) => {
      slide.setAttribute('aria-hidden', `${index !== relativeIndex}`);
    });
  }

  #handleVisibility = () => (document.hidden ? this.pause() : this.resume());
}

if (!customElements.get('bbd-announcement-bar-component')) {
  customElements.define('bbd-announcement-bar-component', BbdAnnouncementBar);
}
